import { AxiosRequestConfig } from "axios";
import { CancelTokenSource } from "axios";
import { SelectFieldOption } from "controls/global/select-field/SelectInput";
import { StoreActionApi } from "react-sweet-state";

import { axiosSecuredInstance } from "configurations/axiosConfig";
import { createHook } from "react-sweet-state";
import { createStore } from "react-sweet-state";

export interface KeyValuePair {
  key: string;
  value: string;
}

export interface AgencyLocation extends SelectFieldOption {
  id: string;
  disabled?: boolean;
}

interface State {
  error: string | null;
  isLoading: boolean;
  agencyStates: Array<SelectFieldOption>;
  isRetrievingStates: boolean;
  isRetrievingAgencyLocations: boolean;
  axiosCancelToken?: CancelTokenSource;
}

type StoreApi = StoreActionApi<State>;

const setError =
  (error: string | null) =>
  ({ setState }: StoreApi) => {
    setState({ error });
  };

const setDefaultState =
  () =>
  ({ setState }: StoreApi) => {
    setState({
      agencyStates: [],
    });
  };

const getData =
  (url: string, action: (param: Array<any>) => ({ setState }: StoreApi) => any, config?: AxiosRequestConfig) =>
  async ({ dispatch }: StoreApi) => {
    try {
      const { data } = await axiosSecuredInstance.get(url, config);
      dispatch(action(data));
      return data;
    } catch (error: any) {
      dispatch(setError(error));
    }
  };

const setAgencyStates =
  (data: Array<any>, isUpdate: boolean = false) =>
  ({ setState }: StoreApi) => {
    setState({
      agencyStates: data.map((state) => ({
        text: state.stateAbbr,
        value: state.stateCode,
      })),
      isRetrievingStates: isUpdate,
    });
  };

const defaultState = {
  agencies: [],
  agencyLocations: [],
  error: null,
  isLoading: false,
  agencyStates: [],
  isRetrievingStates: false,
  isRetrievingAgencyLocations: false,
};

const Store = createStore<State, any>({
  initialState: defaultState,
  actions: {
    getAgencyStates:
    (agencyId?: string) =>
    async ({ dispatch, setState, getState }: StoreApi) => {
      let url = "";
      if (agencyId) {
        url = `/company/GetStatesByCompanyID?companyID=${agencyId}`;            
        if (!getState().isRetrievingStates) {
          setState({ isRetrievingStates: true });
          await dispatch(getData(url, setAgencyStates));
        }
      } else {
        setState({
          agencyStates: [],
          isRetrievingStates: false,
        });
      }
      //else url = "/lookup/getstatelist?countryCodeNum=840";
    },
    resetLookups:
      () =>
      ({ dispatch }: StoreApi) => {
        dispatch(setDefaultState());
      },
  },
  name: "registrationLookup",
});

const hook = createHook(Store);
export const useRegistrationLookup = () => {
  return hook();
};
